import * as dealerTypes from 'modules/dealers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

/**
 * @typedef {import('modules/predefinedMessages/types').PredefinedMessage} PredefinedMessage
 * @typedef {import('../../types').PutPredefinedMessageSuccessAction | import('../../types').PostPredefinedMessageSuccessAction | import('../../types').FetchPredefinedMessageSuccessAction} SetPredefinedMessageSuccessAction
 * @typedef {import('../../types').FetchAllByDealerIdSuccessAction | import('../../types').FetchPredefinedMessagesSuccessAction} SetPredefinedMessagesSuccessAction
 */

const initialState = {};

/**
 * @param {PredefinedMessage} unformatted
 */
const cleanPredefinedMessage = unformatted => {
  const { dealer, group, link, ...formatted } = unformatted;
  return {
    ...formatted,
    dealerId: formatted.dealerId ?? formatted.dealer?.id,
    groupId: formatted.groupId ?? formatted.group?.id,
    createdById: formatted.createdById ?? formatted.createdBy?.id,
    modifiedById: formatted.modifiedById ?? formatted.modifiedBy?.id,
  };
};

/**
 * @param {Object} state
 * @param {SetPredefinedMessagesSuccessAction} action
 */
const updatePredefinedMessages = (state, { payload }) =>
  payload.content?.reduce(
    (newState, predefinedMessage) => updatePredefinedMessage(newState, { payload: predefinedMessage }),
    state
  ) ?? state;

/**
 * @param {Object} state
 * @param {SetPredefinedMessageSuccessAction} action
 */
const updatePredefinedMessage = (state, { payload }) => ({
  ...state,
  [payload.id]: {
    ...(state[payload.id] ?? {}),
    ...cleanPredefinedMessage(payload),
  },
});

export default createReducer(initialState, {
  [actionTypes.FETCH_ALL_BY_DEALER_SUCCESS]: updatePredefinedMessages,
  [dealerTypes.PREDEFINED_MESSAGES_FETCH_SUCCESS]: updatePredefinedMessages,
  [actionTypes.FETCH_FIND_DEALER_OR_GROUP_SUCCESS]: updatePredefinedMessages,
  [actionTypes.FETCH_PREDEFINED_MESSAGES_SUCCESS]: updatePredefinedMessages,
  [actionTypes.FETCH_PREDEFINED_MESSAGE_SUCCESS]: updatePredefinedMessage,
  [actionTypes.CREATE_SUCCESS]: updatePredefinedMessage,
  [actionTypes.UPDATE_SUCCESS]: updatePredefinedMessage,
});
